export default "__VITE_ASSET__CRpiak5B__"